import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 w-full bg-black border-b border-yellow-500 py-3 px-4 shadow-lg" data-id="element-36">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-center sm:text-left" data-id="element-37">
        <div className="flex items-center gap-2" data-id="element-38">
          <span className="animate-pulse h-3 w-3 rounded-full bg-red-500" data-id="element-39"></span>
          <p className="text-white font-bold text-sm sm:text-base uppercase tracking-wide" data-id="element-40">
            <span className="text-yellow-400" data-id="element-41">OFERTA LIMITADA:</span> Solo
            quedan 7 copias disponibles
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-42">
          <span className="text-gray-300 text-xs sm:text-sm uppercase font-semibold hidden sm:inline" data-id="element-43">
            Expira en:
          </span>
          <CountdownTimer data-id="element-44" />
        </div>
      </div>
    </div>;
}